<template>
  <div class="tw-space-y-4">
    <loading-button x-large full-width class="tw-h-20" />

    <div
      class="game-tile-background-color tw-animate-pulse tw-w-full tw-h-32"
    />
  </div>
</template>

<script>
import LoadingButton from '@components/Loading/LoadingButton.vue'
export default {
  components: {
    LoadingButton,
  },
  props: {
    ratingBar: {
      type: Boolean,
      default: false,
    },
    shareButton: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
